import { render } from "./Landlords_List.vue?vue&type=template&id=6dec0e54"
import script from "./Landlords_List.vue?vue&type=script&lang=js"
export * from "./Landlords_List.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__